/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FacilityServiceArea } from './FacilityServiceArea';
import {
    FacilityServiceAreaFromJSON,
    FacilityServiceAreaFromJSONTyped,
    FacilityServiceAreaToJSON,
} from './FacilityServiceArea';

/**
 * 
 * @export
 * @interface CreateFacilityServiceArea201Response
 */
export interface CreateFacilityServiceArea201Response {
    /**
     * 
     * @type {FacilityServiceArea}
     * @memberof CreateFacilityServiceArea201Response
     */
    data?: FacilityServiceArea;
}

/**
 * Check if a given object implements the CreateFacilityServiceArea201Response interface.
 */
export function instanceOfCreateFacilityServiceArea201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateFacilityServiceArea201ResponseFromJSON(json: any): CreateFacilityServiceArea201Response {
    return CreateFacilityServiceArea201ResponseFromJSONTyped(json, false);
}

export function CreateFacilityServiceArea201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFacilityServiceArea201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FacilityServiceAreaFromJSON(json['data']),
    };
}

export function CreateFacilityServiceArea201ResponseToJSON(value?: CreateFacilityServiceArea201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FacilityServiceAreaToJSON(value.data),
    };
}

